import React from 'react';
import RootCommentBox from '../comment-box/root-comment-box';
import { useApi } from '../../context/api-context/use-api';
import { getIsMobile, getIsSSR } from '../../../common/store/base-params/base-params-selectors';
import { resolveSomeoneIsTyping } from './resolve-someone-is-typing';
import CommentingLockedEmptyState from '../../empty-states/commenting-locked-empty-state';
import { classes } from './end-root-box-section.st.css';
import LoginRequiredEmptyState from '../../empty-states/login-required-empty-state';
import { unreachable } from '../../../ts-utils';
const EndRootBoxSectionNoMemo = ({ addCommentPermission, someoneIsTyping }) => {
    const { someoneIsTypingDev, isSSR, isMobile } = useApi((state, _actions, _, ctx) => ({
        loginRequiredDev: ctx.wcDevToolsState.specialStates === 'login_required',
        someoneIsTypingDev: ctx.wcDevToolsState.showSomeoneIsTyping,
        isSSR: getIsSSR(state),
        isMobile: getIsMobile(state),
    }));
    const renderState = () => {
        if (addCommentPermission.type === 'ALLOW') {
            return (React.createElement(React.Fragment, null,
                !isSSR && resolveSomeoneIsTyping('end', someoneIsTypingDev, someoneIsTyping),
                React.createElement(RootCommentBox, { position: "end", shoudDispatchIAmTyping: addCommentPermission.precondition === 'NONE' ||
                        addCommentPermission.precondition === 'GUEST_FLOW', withGuestFlow: addCommentPermission.precondition === 'GUEST_FLOW' })));
        }
        const { reason } = addCommentPermission;
        switch (reason) {
            case 'LOCKED':
                return React.createElement(CommentingLockedEmptyState, { isMobile: isMobile });
            case 'LOGIN_REQUIRED':
                return React.createElement(LoginRequiredEmptyState, null);
            case 'UNKNOWN':
                return null;
            default:
                throw unreachable(reason);
        }
    };
    return React.createElement("div", { className: classes.root }, renderState());
};
const EndRootBoxSection = React.memo(EndRootBoxSectionNoMemo);
export default EndRootBoxSection;
//# sourceMappingURL=end-root-box-section.js.map